
import { jwtDecode } from 'jwt-decode';
import { useEffect } from 'react';
import { limpiarSesion, obtenerToken } from '../helpers/tokenSesion';
import { RUTA_LANDING, RUTA_LOGIN } from '../constants/rutas';
//import { useNavigate } from 'react-router-dom';

const useCheckTokenExpiration = () => {
   // const navigate = useNavigate();

    useEffect(() => {
        const token = obtenerToken();

        if (token) {
            const decodedToken = jwtDecode(token);
            const currentTime = Date.now() / 1000; // en segundos
            if (decodedToken.exp < currentTime) {
                // Si el token ha expirado
                limpiarSesion();
                // Redirige al inicio de sesión (la landing pública no lo necesita)
                if (window.location.pathname !== RUTA_LANDING) window.location.href = RUTA_LOGIN

            }
        }
    }, []);
};

export default useCheckTokenExpiration;
